import styled from '@emotion/styled';
import { Link } from 'gatsby';

const FormSection = styled.section`
  width: 100%;
  display: block;
  margin-top: 0;
`;

const FormGroup = styled.div`
  margin-bottom: 1rem;

  label {
    width: 100%;
    display: inline-block;
    margin-bottom: 0.5rem;
    font-size: 1.2rem;
    padding-left: 2px;
    color: var(--darkText);
  }

  input {
    display: block;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: var(--darkText);
    background-color: var(--textField);
    background-clip: padding-box;
    border: 1px solid var(--pronouncedBorder);
    border-radius: 0.25rem;
  }

  textarea {
    resize: vertical;
    display: block;
    width: 100%;
    min-height: calc(1.5em + 0.75rem + 2px);
    max-height: 100px;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: var(--darkText);
    background-color: var(--textField);
    background-clip: padding-box;
    border: 1px solid var(--pronouncedBorder);
    border-radius: 0.25rem;
  }

  span {
    color: var(--cta);
  }
`;

const LinkContainer = styled.div`
  position: relative;
  margin-bottom: 1rem;
`;

const StyledLink = styled(Link)`
  color: var(--darkText);
  font-weight: 700;

  :hover {
    text-decoration: underline;
  }
`;

export { FormSection, FormGroup, LinkContainer, StyledLink };
